let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cUOrJ")).then(() => parcelRequire('azaOO'));